import { TextFieldProps, TextField } from "@mui/material";
import { FC, useMemo } from "react";
import { hEncode } from "~/utils/hashid";

const ReadonlyField: FC<TextFieldProps> = (props) => {
  const uid = useMemo(() => 'readonly-field-' + hEncode(new Date().getMilliseconds()), [])
  return (
    <TextField
      id={uid}
      fullWidth
      variant="outlined"
      InputProps={{
        readOnly: true,
        tabIndex: -1,
      }}
      {...props}
      sx={{ 
        ...props.sx,
        fontStyle: 'italic',
        color: theme => theme.palette.text.secondary,
      }}
      inputProps={{
        tabIndex: -1,
        ...props.inputProps,
      }}
    />
  )
}

export default ReadonlyField;

